import React, { useState, useEffect } from "react";
import "./Formheader.css";
import { IoMdFolderOpen } from "react-icons/io";
import { FiStar } from "react-icons/fi";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Snackbar,
} from "@material-ui/core";
import Alert from "@mui/material/Alert";
import Avatar from "@material-ui/core/Avatar";
import { IoMdEye } from "react-icons/io";
import { Link, useParams, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { app } from "../firebase";

const Formheader = ({ formName, photoURL, value, handleSaveAsDraft }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [savingProfile, setSavingProfile] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: "", severity: "success" });
  const user = auth.currentUser;

  const [resolvedFormName, setResolvedFormName] = useState(formName || "");

  useEffect(() => {
    if (formName) {
      setResolvedFormName(formName);
    } else if (id) {
      const db = getFirestore(app);
      getDoc(doc(db, "forms", id)).then((snap) => {
        if (snap.exists() && snap.data().formName) {
          setResolvedFormName(snap.data().formName);
        }
      }).catch((err) => console.error("Error loading formName in header:", err));
    }
  }, [formName, id]);

  useEffect(() => {
    if (!user) return;
    setDisplayName(user?.displayName || "");
    const ref = doc(getFirestore(app), "userprofilemaster", user.uid);
    getDoc(ref).then((snap) => {
      if (snap.exists() && snap.data().displayName) {
        setDisplayName(snap.data().displayName);
      }
    });
  }, [user]);

  const handleProfileOpen = () => {
    setProfileDialogOpen(true);
    setAnchorElUser(null);
  };

  const handleProfileClose = () => {
    setProfileDialogOpen(false);
  };

  const handleProfileSave = async () => {
    if (!user) return;
    setSavingProfile(true);
    try {
      await updateProfile(user, { displayName });
      const ref = doc(getFirestore(app), "userprofilemaster", user.uid);
      await updateDoc(ref, { displayName });
      setSnack({ open: true, msg: "Profile updated successfully!", severity: "success" });
      handleProfileClose();
    } catch (err) {
      setSnack({ open: true, msg: "Failed to save changes.", severity: "error" });
    }
    setSavingProfile(false);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const logout = async () => {
    try {
      await auth.signOut();
      sessionStorage.clear();
      handleCloseUserMenu();
      navigate('/signin', { replace: true });
    } catch (error) {
      console.error("Unable to sign out:", error);
    }
  };
  const handleEyeIconClick = () => {
    navigate(`/form/${id}/preview`);
  };

  return (
    <div className="form_header">
      <div className="form_header_left">
        <input
          type="text"
          placeholder="Form Name"
          value={resolvedFormName}
          onChange={(e) => setResolvedFormName(e.target.value)}
          className="form_name"
        />
        <IoMdFolderOpen
          className="form_header_icon"
          style={{ marginRight: "10px" }}
        ></IoMdFolderOpen>
        <FiStar className="form_header_icon" style={{ marginRight: "10px" }} />
      </div>
      <div className="form_header_right">
        <Link to={`/form/${id}/preview`}>
          <IconButton onClick={handleEyeIconClick}>
            <IoMdEye className="form_header_icon" />
          </IconButton>
        </Link>

        <Tooltip title="Open settings">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar src={photoURL || undefined} style={{ width: "30px", height: "30px", backgroundColor: "#1767e8", fontSize: "13px", fontWeight: 700 }} alt={value || "Account"}>A</Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem onClick={handleProfileOpen}>Profile Settings</MenuItem>
          <MenuItem onClick={logout}>
            <Typography textAlign="center">Logout</Typography>
          </MenuItem>
        </Menu>
      </div>

      <Dialog open={profileDialogOpen} onClose={handleProfileClose} maxWidth="sm" fullWidth>
        <DialogTitle>Profile Settings</DialogTitle>
        <DialogContent sx={{ py: 3 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Display Name"
            type="text"
            fullWidth
            variant="outlined"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleProfileClose}>Cancel</Button>
          <Button onClick={handleProfileSave} variant="contained" disabled={savingProfile}>
            {savingProfile ? "Saving…" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snack.open}
        autoHideDuration={3500}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.severity} sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Formheader;
